import { Component, OnInit, ViewContainerRef, ViewChild, ViewEncapsulation, Inject, ChangeDetectorRef, SimpleChanges, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { filters, sortingObj, returnTimesheet, deletepermission, gettimesheet, WhereCondition, functionpermission, employeeFilter, EventEmitterTimesheetBo } from '../timesheet.model';
import { IMyDpOptions } from 'mydatepicker';
import { ToastrService } from 'ngx-toastr';
import * as pbi from "powerbi-client";
import { DetailRowService, GridModel, parentsUntil, DataStateChangeEventArgs, EditService, QueryCellInfoEventArgs, ToolbarItems, ToolbarService, IEditCell, AggregateService } from '@syncfusion/ej2-angular-grids';
import { FilterSettingsModel, IFilter, GridComponent } from '@syncfusion/ej2-angular-grids';
import { DatePipe } from '@angular/common';
import { Observable } from 'rxjs';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { EnvironmentService } from "src/app/environment.service";
import { DateService } from 'src/app/date.service';
import { GlobalComponent } from 'src/app/global/global.component';
import { TimesheetViewService } from './timesheet-view.service';
import { CommonApiService } from 'src/app/commonapiservice';
import { EditDetailsAuthorization } from '../../client-parent/client-parent.model';
import { ColumnChangeBO, columnWidth } from '../../employee/employee.model';
@Component({
  selector: 'app-timesheet-view',
  templateUrl: './timesheet-view.component.html',
  styleUrls: ['./timesheet-view.component.scss'],
  providers: [DetailRowService, EditService, ToolbarService, AggregateService],
  encapsulation: ViewEncapsulation.None,
})
export class TimesheetViewComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  @Input() ViewInputProperty: EventEmitterTimesheetBo = new EventEmitterTimesheetBo();
  @Output() ViewOutputTimesheet = new EventEmitter<EventEmitterTimesheetBo>();
  filters: filters = new filters();
  @ViewChild('childtemplate') public childtemplate: any;
  @ViewChild('gridTimesheet') public gridTimesheet: GridComponent;
  @ViewChild('gridTimesheetUpload') public gridTimesheetUpload: GridComponent;
  saveErr: string = "";
  // edi271list: EDI271BO[] = []
  fp: functionpermission = new functionpermission()
  EmployeeDropDown: any = []
  viewFiles271: boolean = false;
  TimesheetDataList: any = [];
  totalhrsSummary: number = 0;
  totalhrsSummaryMinstr: string;
  public dropdatas: string[] = ['Yes', 'No']
  public dropdata1: string[] = ['', "EXPORTED"]
  public height = '220px';
  filterOptions: FilterSettingsModel;
  initialPage: object;
  filter: IFilter;
  AllEmployeeDropDownListwithStatus: any = [];
  AllClientDropDownListwithStatus: any = [];
  sorting = new sortingObj();
  authinput: EditDetailsAuthorization = new EditDetailsAuthorization();
  deleteList: deletepermission = new deletepermission();
  empumpi: any = [];
  gettimesheet: gettimesheet = new gettimesheet();
  conditionlist: WhereCondition[] = [];
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  public formatOptions: object;
  ColumnArray: columnWidth[]
  ColumnArray_timesheetupload: columnWidth[]
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  id: number = 0;
  arraycol: any = [];
  public toolbar: ToolbarItems[];
  isNewValidationBoolean: boolean = false;
  TimesheetLst: returnTimesheet[];
  parentData: any = [];
  childData: any = [];
  childGrid: GridModel;
  public editSettings: Object;
  GridTimesheetUploadList: any = [];
  EditAuthorization: boolean = false;
  end: string;
  Employee: number;
  Client: number;
  AuthorizationDetails: any = [];
  griddata: boolean = false
  eanbleend: boolean = true;
  eanbleservice: boolean = true;
  isEmp: boolean = false;
  isCliInfo: boolean = false;
  umpi: string;
  
  payorreqID: string;
  EmployeeAka: string;
  serviceName: any = [];
  clientdob: string;
  memberma: string;
  ClientAka: string = "";
  ValidationDate: any;
  manualEntry: boolean = false;
  orderList: any = [];
  passerror: boolean = false;
  isIns: boolean = false;
  dontshowAuth: boolean = false;
  createSchList: any = []
  hoursCal: any = false;
  result2: any = []
  Allhours: string = "";
  enterdhr: number = 0;
  entermin: number = 0;
  selected: boolean = false;
  pdfSrc: string = "";
  filearray: any = [];
  resetPass: FormGroup;
  editemp: any;
  StartDate: any = "";
  EndDate: any = "";
  masterServiceId: any;
  clientAuthorizationId: any;
  editcli: any;
  checkReport: boolean = true;
  editserialnumber: number;
  EmployeeId: string;
  editClient: string;
  editEmployee: any;
  editid: number;
  editDate: string;
  editservice: any;
  edittime: string;
  isColorEditValue: boolean[] = [];
  editNotes: string;
  edithours: string = "";
  timesheetreportEmployee: any;
  timesheetreportClient: any;
  printserviceFilter: any;
  employeeFilter = new employeeFilter();
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 },
    showClearDateBtn: false,
    editableDateField: true
  };
  @ViewChild("reportContainer", { static: false }) reportContainer: ElementRef;
  public GridDataList: Observable<DataStateChangeEventArgs>;
  public state: DataStateChangeEventArgs;
  EmployeeListData: any;
  public dpParams: IEditCell;
  public timesheetsToEdit = [];
  public customParentTHAttributes?: Object;
  public timesheetsToDelete = [];
  AllEmployeeDropDownList: any = [];
  AllClientDropDownList: any = [];
  serviceGroupFilter: any;
  locationLid: any = 0;
  reportHeader: any = "";
  configuration: any;
  filterStartDateTimesheet: any;
  filterEndDateTimesheet: any;
  deleteId: any;
  clientId: any;
  GridType: any = "";
  serialNo: number = 0
  ServiceCodeFilter: any;
  timesheetIsLinkedList:any
  timesheetTotalColumns:number=8;
  constructor(private ref: ChangeDetectorRef, public dateservice: DateService,
    private cdr: ChangeDetectorRef,
    public global: GlobalComponent,
    public ViewService: TimesheetViewService, public toastrService: ToastrService,public EnvironmentService: EnvironmentService,
     public CommonAPI: CommonApiService,
    public datePipe: DatePipe, @Inject(ViewContainerRef) private viewContainerRef?: ViewContainerRef) {
    this.global.agencyList();
   this.configuration = this.EnvironmentService.getEnvironmentsConfiguration();
    this.GridDataList = ViewService;
    this.resetPass = new FormGroup({
      Password: new FormControl('', [Validators.required])
    });
  }
  //.................................................ngAfterContentChecked........................................................
  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }
  //.................................................ngOnInit........................................................
  ngOnInit() {
        this.clearGridLocalStorage();
    if (this.global.globalAgencyId == null || this.global.globalAgencyId == '' || this.global.globalAgencyId == undefined || this.global.globalAgencyId == 0 || this.global.globalAgencyId == '00000000-0000-0000-0000-000000000000') {
      return;
    }
    this.customParentTHAttributes = { id: 'ParentTimesheetTotalHours' };
    if (this.global.selectedLocationDropdown == null || this.global.selectedLocationDropdown == undefined || this.global.selectedLocationDropdown == '') {
      this.locationLid = "00000000-0000-0000-0000-000000000000";

    }
    else {
      this.locationLid = this.global.selectedLocationDropdown;
    }
    this.dpParams = { params: { format: 'MM/dd/yyyy' } };
    this.timesheetIsLinkedList=[
      {
        'Key':true,
        'Value':'Linked Authorization'
      },
      {
        'Key':false,
        'Value':'Not Linked Authorization'
      }
    ]
    this.getClientDropDown();
    this.getEmployeeDropDown();

    if (this.ViewInputProperty.isEntry == false) {
      this.FunctionPermission();
    }
    this.getServiceCode();
    this.getPayorDropDown();
    // this.getCommonClientListByAgency();
    if (this.global.InactiveClientTimesheets == true) {
      this.filters.filterStartDate = this.datePipe.transform(this.global.InactiveClientTimesheetsFromDate, "MM/dd/yyyy");
      this.filters.filterEndDate = this.datePipe.transform(this.global.InactiveClientTimesheetsToDate, "MM/dd/yyyy");
      let clientId: string;
      clientId = this.global.InactiveClientId;
      this.filters.filterClient =clientId;
    }
    else {
      this.filters.filterStartDate = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
      this.filters.filterEndDate = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
    }
    this.filterEndDateTimesheet = new Date();
    this.filterEndDateTimesheet.setDate(new Date().getDate() + 6);
    this.filterStartDateTimesheet = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
    this.filterEndDateTimesheet = (this.filterEndDateTimesheet.getMonth() + 1) + '/' + this.filterEndDateTimesheet.getDate() + '/' + this.filterEndDateTimesheet.getFullYear();
    this.filterOptions = { type: 'Menu' };
    this.filter = {
      type: 'menu'
    };
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };
    // let pag = JSON.parse(this.global.globalColumn.column)[0].Timesheet.Pagesize;
    let pag = 10;
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: pag, pageSize: pag, pageSizes: this.pageSizes };
    this.ApplyFilter();
    // this.getEmployeeUMPI();
    this.editSettings = { allowEditing: true, allowAdding: true, allowDeleting: true };
    this.toolbar = ['Add', 'Edit', 'Update', 'Cancel'];
    this.conditionlist.push(new WhereCondition());
    this.childGrid = {
      dataSource: this.childData,
      queryCellInfo: this.customiseCell,
      queryString: 'combinedSerialNumber',
      allowSorting: false,
      allowPaging: false,
      load() {
        this.registeredTemplate = {};
      },
      columns: [
     //   { field: 'Edit', headerText: 'Edit', width: 50, template: this.childtemplate, allowEditing: false },
        { field: 'timesheetDate', headerText: 'Timesheet Date', width: 75, },
        { field: 'masterCode', headerText: 'Service', width: 100, },
        { field: 'payer', headerText: 'Payer', width: 80, },
        { field: 'totalHours', headerText: 'Total Hours', width: 100, customAttributes: { id: 'ChildTimesheetTotalHours' } },
        { field: 'notes', headerText: 'Notes', width: 50, },
  //      { field: 'paidpayroll', headerText: 'Paid Payroll', width: 50, },
      ]
    };
    this.toolbar = ['ColumnChooser'];
    this.gettimesheet.pageitem = pag
    setTimeout(() => {
    }, 300);
  }
  //.................................................Refresh........................................................
  Refresh() {
    this.filters.filterStartDate = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
    this.filters.filterEndDate = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
    this.calculateValidateDate();
    this.sorting.itemperpage = 10;
    this.sorting.currentPgNo = 1;
    this.gettimesheet.value = "";
    this.filters.filterEmployee =  "00000000-0000-0000-0000-000000000000";
    this.filters.filterClient =  "00000000-0000-0000-0000-000000000000";
    this.filters.filterPayor =  "00000000-0000-0000-0000-000000000000";
    this.serviceGroupFilter = 0;
    this.serviceGroupFilter = null;
    this.ServiceCodeFilter = 0;
    this.ServiceCodeFilter = null;
    this.gettimesheet.field = "Client"
    this.sorting.shortcolumn = "TimesheetDate"
    this.sorting.shortType = 'ASC';
    this.employeeFilter.employeeType = null;
    this.filters.filterIsTImesheetLinked=null;
    this.ApplyFilter();
    this.gridTimesheet.clearFiltering();
    this.gridTimesheet.clearSorting();
  }
  //.................................................TimesheetViewDatePickers........................................................
  TimesheetViewDatePickers(event, type, name) {
    if (type == "inputchanged") {
      if (name == 'filterstart') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.filters.filterStartDate = val1;
        }
      }
      if (name == 'filterend') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.filters.filterEndDate = val1;
        }
      }
      if (name == 'editdate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.editDate = val1;
        }
      }
    }
    if (type == "datachanged") {
      if (name == 'filterstart') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.filters.filterStartDate = val1;
          this.calculateValidateDate();
          this.clearEndTimeValidation();
        }
      }
      if (name == 'filterend') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.filters.filterEndDate = val1;
          this.clearEndTimeValidation();
        }
      }
      if (name == 'editdate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.editDate = val1;
          this.clientAuthorizationId = null;
          this.getAuthorizationDetails();
        }
      }
    }
  }
  //.................................................clearEndTimeValidation........................................................
  clearEndTimeValidation() {
    if (this.filters.filterStartDate != null && this.filters.filterStartDate != undefined && this.filters.filterStartDate != ''
      && this.filters.filterEndDate != null && this.filters.filterEndDate != undefined && this.filters.filterEndDate != '') {
      if (this.filters.filterEndDate != null && this.filters.filterEndDate != undefined && this.filters.filterEndDate != '') {
        if (new Date(this.filters.filterStartDate).getTime() > new Date(this.filters.filterEndDate).getTime()) {
          this.filters.filterEndDate = null;
          this.toastrService.error("end time should greater than start time");
          setTimeout(() => {
            this.toastrService.clear();
          }, 3000);
          return;
        }
      }
    }
  }
  //.................................................refreshtoPayorDropdownValues........................................................
  refreshtoPayorDropdownValues() {
    let url = 'api/Payer/CommonGetGPList?'
    this.CommonAPI.RefreshDropDownList('Payor', "", url, "PayorDropDown").then((data: any) => {
      this.ViewInputProperty.PayorDropDown = JSON.parse(JSON.stringify(data))
    })
  }
  //.................................................getPayorDropDown........................................................
  getPayorDropDown() {
    let url = 'api/Payer/CommonGetGPList?'
    this.CommonAPI.getDropDownList('Payor', "", url, "PayorDropDown").then((data: any) => {
      this.ViewInputProperty.PayorDropDown = JSON.parse(JSON.stringify(data))
    });
  }
  //.................................................getService........................................................

  //.................................................ApplyFilter........................................................
  ApplyFilter() {
    if (this.serviceGroupFilter == null || this.serviceGroupFilter == undefined || this.serviceGroupFilter == '') {
      this.serviceGroupFilter = "00000000-0000-0000-0000-000000000000";
    }
    if (this.ServiceCodeFilter == null || this.ServiceCodeFilter == undefined || this.ServiceCodeFilter == '') {
      this.ServiceCodeFilter = "00000000-0000-0000-0000-000000000000";
    }
    if (this.filters.filterEmployee == null || this.filters.filterEmployee == undefined) {
      this.filters.filterEmployee = "00000000-0000-0000-0000-000000000000"
    }
    if (this.filters.filterClient == null || this.filters.filterClient == undefined) {
      this.filters.filterClient = "00000000-0000-0000-0000-000000000000"
    }
    if (this.filters.filterPayor == null || this.filters.filterPayor == undefined) {
      this.filters.filterPayor ="00000000-0000-0000-0000-000000000000"
    }

    if (this.filters.filterStartDate != null && this.filters.filterStartDate != undefined && this.filters.filterStartDate != ''
      && this.filters.filterEndDate != null && this.filters.filterEndDate != undefined && this.filters.filterEndDate != '') {


      let EndDate = this.datePipe.transform(this.filters.filterEndDate, "MM/dd/yyyy");

      if ((new Date(EndDate).getTime() > new Date(this.ValidationDate).getTime()) && ((this.filters.filterEmployee == null || this.filters.filterEmployee == undefined || this.filters.filterEmployee ==  "00000000-0000-0000-0000-000000000000")
        && (this.filters.filterClient == null || this.filters.filterClient == undefined || this.filters.filterClient == "00000000-0000-0000-0000-000000000000"))) {
        this.toastrService.error("Date range should not be greater than 1 year");
        this.filters.filterEndDate = null;

        setTimeout(() => {
          this.toastrService.clear();
        }, 3000);

      }
      else {
        this.getTimesheetListFilter();
      }
    }
    this.calculateValidateDate();
  }
  //.................................................calculateValidateDate........................................................
  calculateValidateDate() {
    var StartDate = new Date(this.filters.filterStartDate);
    let setDate = StartDate.setDate(StartDate.getDate() + 365);
    let getDate = setDate;
    this.ValidationDate = this.datePipe.transform(getDate, "MM/dd/yyyy");
  }
  //.................................................tobase64........................................................
  tobase64 = value => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(value);
    reader.onload = (e: any) => resolve(e.target.result);
    reader.onerror = error => reject(error);
  });
  //.................................................onFileChanged........................................................
  async onFileChanged(event) {
    let i = 0;
    for (i = 0; i < event.target.files.length; i++) {
      let val = await this.tobase64(event.target.files[i]);
      this.selected = true;
      this.filearray[i] = { "TimesheetUploadName": event.target.files[i].name, "uploadtimesheet": val }
    }
    this.pdfSrc = this.filearray[0].uploadtimesheet;
  }
  //.................................................getTimesheetListFilter........................................................
  getTimesheetListFilter() {
    this.gettimesheet.client =this.filters.filterClient.toString();
    this.gettimesheet.payor = this.filters.filterPayor.toString();
    this.gettimesheet.pageitem = parseInt(this.sorting.itemperpage.toString());
    this.gettimesheet.employee =this.filters.filterEmployee.toString();
   // this.gettimesheet.service = parseInt(this.serviceGroupFilter.toString());
    this.gettimesheet.serviceCode = this.ServiceCodeFilter?.toString();
    this.gettimesheet.start = this.global.getDateTimeString(this.filters.filterStartDate);
    this.gettimesheet.end = this.global.getDateTimeString(this.filters.filterEndDate);
    this.gettimesheet.isAuthLinked = this.filters.filterIsTImesheetLinked;
    this.gettimesheet.currentpageno = this.sorting.currentPgNo;
    this.gettimesheet.orderColumn = this.sorting.shortcolumn;
    this.gettimesheet.orderType = this.sorting.shortType;
    this.gettimesheet.locationLid = this.locationLid;
    this.ViewService.executeViewList(this.gettimesheet)
    let count = 0;
    this.GridDataList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.count= data.count
      this.TimesheetDataList = data.result;
      this.childData = this.ViewService.getchilddata()
      this.TimesheetLst = this.ViewService.timelst;
      count = count + 1;
      if (data != null && data != undefined && count == 1) {
        // this.getColumnwidth();
      }
      this.totalhrsSummary = 0;
      this.totalhrsSummary = parseFloat(this.totalhrsSummary.toString()) + parseFloat(data.totalHours);
      let hrMinStr = this.totalhrsSummary.toString().split('.');
      if (hrMinStr.length == 1) {
        this.totalhrsSummaryMinstr = hrMinStr[0] + " hr " + "0 Min";
      }
      else {
        let minStr = 0 + "." + hrMinStr[hrMinStr.length - 1];
        this.totalhrsSummaryMinstr = hrMinStr[0] + " hr " + (parseFloat(minStr) * 60).toString().split('.')[0] + "Min";
      }
      this.childGrid = {
        dataSource: this.childData,
        queryCellInfo: this.customiseCell,
        queryString: 'combinedSerialNumber',
        allowSorting: false,
        allowPaging: false,
        load() {
          this.registeredTemplate = {};
        },
        columns: [
         // { field: 'Edit', headerText: 'Edit', width: 50, template: this.childtemplate, allowEditing: false },
          { field: 'timesheetDate', headerText: 'Timesheet Date', width: 75, },
          { field: 'masterCode', headerText: 'Service', width: 100, },
          { field: 'payer', headerText: 'Payer', width: 80, },
          { field: 'totalHours', headerText: 'Total Hours', width: 100, customAttributes: { id: 'ChildTimesheetTotalHours' } },
          { field: 'notes', headerText: 'Notes', width: 50, },
        //  { field: 'paidpayroll', headerText: 'Paid Payroll', width: 50, },
        ]
      };
      this.gridTimesheet.childGrid.dataSource = this.childData;
      if (data.result.length > 10) {
        this.gridTimesheet.height = '500';
      }
      else {
        this.gridTimesheet.height = 'auto';
      }
    })
  }
  //.................................................onActionComplete........................................................
  public onActionComplete(args) {
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.gridTimesheet.columns.forEach(element => {
        if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
          hidearr.push(element.headerText);
        }
        if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
          showarr.push(element.headerText);
        }
      })
      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {
        if (this.arraycol.length > 0) {
          this.arraycol[0].Timesheet.ShowColumns.forEach(old => {
            showarr.forEach(element => {
              if (old == element) {
                count1 = count1 + 1;
              }
            });

          });

          this.arraycol[0].Timesheet.HideColumns.forEach(old => {
            hidearr.forEach(element => {
              if (old == element) {
                count = count + 1;
              }
            });
          });
          if (this.arraycol[0].Timesheet.ShowColumns.length != count1 || this.arraycol[0].Timesheet.HideColumns.length != count) {
            this.arraycol[0].Timesheet.ShowColumns = showarr;
            this.arraycol[0].Timesheet.HideColumns = hidearr;
            this.arraycol[0].Timesheet.Pagesize = this.gridTimesheet.pagerModule.pagerObj.pageSize
            this.SaveColumnwidth();
          }
        }
      }
    }
    this.conditionlist = [];
    if (args.requestType == "filterafteropen") {
      this.gettimesheet.type = args.columnType;
    }
  }
  //.................................................dataStateChange........................................................
  public dataStateChange(state): void {
    let type: String = (state.action.requestType).toString();
    this.sorting.currentPgNo = this.gridTimesheet.pagerModule.pagerObj.currentPage;
    this.sorting.itemperpage = this.gridTimesheet.pagerModule.pagerObj.pageSize;
    if (state.action.requestType != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.sorting.shortcolumn = state.sorted[0].name;
        if (this.sorting.shortcolumn == 'fromDate' || this.sorting.shortcolumn == 'toDate') {
          this.sorting.shortcolumn = "timesheetDate"
        }
        this.sorting.shortType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (type == "filtering" && state.action.action != "clearFilter") {
      // this.sorting.currentPgNo = 1;
      //  this.sorting.itemperpage = 10;
      if (this.gettimesheet.type == "date") {

        this.gettimesheet.value = (new Date(new Date(state.action.currentFilterObject.value).toDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "");
      }
      else {
        this.gettimesheet.value = state.action.currentFilterObject.value
      }
      this.gettimesheet.field = state.action.currentFilterObject.field
      if (state.action.currentFilterObject.field == "isCliSignature") {
        this.gettimesheet.value = this.gettimesheet.value == 'Yes' ? 'true' : 'false';
        this.gettimesheet.type = "boolean"
      }
      if (state.action.currentFilterObject.field == "isEmpSignature") {
        this.gettimesheet.value = this.gettimesheet.value == 'Yes' ? 'true' : 'false';
        this.gettimesheet.type = "boolean"
      }
      if (state.action.currentFilterObject.field == "eTimesheet") {
        this.gettimesheet.value = this.gettimesheet.value == 'Yes' ? 'true' : 'false';
        this.gettimesheet.type = "boolean"
      }
      if (state.action.currentFilterObject.field == "housingCaseNote") {
        this.gettimesheet.value = this.gettimesheet.value == 'Yes' ? 'true' : 'false';
        this.gettimesheet.type = "boolean"
      }
      if (state.action.currentFilterObject.field == "employmentService") {
        this.gettimesheet.value = this.gettimesheet.value == 'Yes' ? 'true' : 'false';
        this.gettimesheet.type = "boolean"
      }
      if (state.action.currentFilterObject.field == "timesheetStatusLid") {
        this.gettimesheet.field = "timesheetStatus"
        this.gettimesheet.type = "string"
      }
      if (state.action.currentFilterObject.field == "paidpayrolls") {
        this.gettimesheet.value = this.gettimesheet.value == 'Yes' ? 'true' : 'false';
        this.gettimesheet.type = "boolean";
      }
    }
    if (state.action.requestType == "filtering" && state.action.action == "clearFilter") {
      this.sorting.currentPgNo = 1;
      this.sorting.itemperpage = JSON.parse(this.global.globalColumn.column)[0].Timesheet.Pagesize;
      this.gridTimesheet.pageSettings.pageSize = JSON.parse(this.global.globalColumn.column)[0].Timesheet.Pagesize;
      this.gridTimesheet.pageSettings.currentPage = 1
      this.gettimesheet.value = ""
      this.gettimesheet.field = "Client"
      this.sorting.shortcolumn = "TimesheetDate"
      this.sorting.shortType = 'ASC';
    }
    if (state.action.requestType != "refresh") {
      this.ApplyFilter();
    }
    if (state.action.requestType == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].Timesheet.Pagesize != state.take) {
          this.arraycol[0].Timesheet.Pagesize = state.take
          this.SaveColumnwidth();
        }
      }
    }
  }
  //.................................................customiseCell........................................................
  customiseCell(args: QueryCellInfoEventArgs) {
    if (args.column.field == "Edit") {
      if (args.data['housingCaseNote'] == true) {
        args.cell.children[0].children[0].classList.add('disableedit');
        args.cell.children[0].children[1].classList.add('disableedit');
      }
      if (args.data['employmentService'] == true) {
        args.cell.children[0].children[0].classList.add('disableedit');
        args.cell.children[0].children[1].classList.add('disableedit');
      }
      if (args.data['timesheetStatusLid'] == 'EXPORTED') {
        args.cell.children[0].children[0].classList.add('disableedit');
        args.cell.children[0].children[1].classList.add('disableedit');
      }
      else if (args.data['etimesheet'] == true) {
        args.cell.children[0].children[0].classList.add('disableedit');
        args.cell.children[0].children[1].classList.add('disableedit');
      }
    }
  }
  //.................................................DeleteChildGrid........................................................
  DeleteChildGrid(data) {
    this.deleteList.timesheet_id = data.timeSheetId;
  }
  //.................................................ngAfterViewInit........................................................
  ngAfterViewInit() {
    this.childtemplate.elementRef.nativeElement._viewContainerRef = this.viewContainerRef;
    this.childtemplate.elementRef.nativeElement.propName = 'template';
  }
  //.................................................validatebutton........................................................
  validatebutton(args: QueryCellInfoEventArgs) {
    if (args.column.field == "timesheet") {
      if (args.data['housingCaseNote'] == "YES") {
        args.cell.children[1].classList.add('disableedit');
        args.cell.children[2].classList.add('disableedit');
      }
      if (args.data['employmentService'] == "YES") {
        args.cell.children[1].classList.add('disableedit');
        args.cell.children[2].classList.add('disableedit');
      }
      if (this.fp.timesheetsdelete) {
        if (args.data['timesheetStatusLid'] == 'EXPORTED' || args.data['eTimesheet'] == "YES") {
          args.cell.children[1].classList.add('disableedit');
          args.cell.children[2].classList.add('disableedit');
        }
      }
      else {
        if (args.data['timesheetStatusLid'] == 'EXPORTED' || args.data['eTimesheet'] == "YES") {
          args.cell.children[1].classList.add('disableedit');
        }
        args.cell.children[2].classList.add('disableedit');
      }
    }
  }
  //.................................................edittimesheet........................................................
  edittimesheet(data, args: any) {
    this.edithours = "";
    this.editserialnumber = data.serialNo;
    let val1 = this.TimesheetLst?.filter(s => s.serialNumber == data.serialNo);
    this.timesheetsToEdit = val1[0]?.timesheet?.map(t => t.id);
    this.editemp = parseInt(val1[0]?.timesheet[0]?.employeeId?.toString());
    this.editcli = parseInt(val1[0]?.timesheet[0]?.clientId?.toString());
    this.masterServiceId = parseInt(val1[0]?.timesheet[0]?.masterServiceId?.toString());
    this.StartDate = data.fromDate;
    this.EndDate = data.toDate;
    this.GridType = "parent";
    this.getAuthorizationDetails();
    this.editservice = parseInt(val1[0]?.timesheet[0]?.masterServiceId?.toString());
   
    this.clientAuthorizationId = data?.authorizationId;
  }
  //.................................................getEmployeeUMPI........................................................
  getEmployeeUMPI() {
    let url = "api/Client/GetEmplUIdInsprvdno?"
    this.CommonAPI.GetFunctionwithResponseTypeJson("", url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.ViewInputProperty.EmployeeUMPI = data;
    })
  }
  //....................................................AddManualEntry.........................................
  AddManualEntry() {
    this.ViewInputProperty.isEntry = true;
    this.ViewInputProperty.LocationLid = this.locationLid;
    this.ViewOutputTimesheet.emit(this.ViewInputProperty);
  }
  //.................................................editTotaltimesheet........................................................
  editTotaltimesheet() {
    let value = {
      serialnumber: this.editserialnumber,
      employee: parseInt(this.editemp),
      client: parseInt(this.editcli),
      clientAuthorizationId: parseInt(this.clientAuthorizationId),
      masterServiceId: parseInt(this.editservice),  
      timesheetIds: this.timesheetsToEdit,
      start: this.global.getDateTimeString(this.StartDate),
      end: this.global.getDateTimeString(this.EndDate),
    }
    let url = "api/Timesheet/BulkupdateofTimesheet"
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(value, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      document.getElementById("editall").click();
      this.ApplyFilter();
      let status: any = "success";
      this.toastrService.success(
        'Timesheet updated successfully!'
      ), 8000;
      this.clientAuthorizationId = null
    },
      (err: any) => {
        this.toastrService.error(
          err,
          "error",
        );
        setTimeout(() => {
          this.toastrService.clear()
        }, 8000);
      })
  }
  //.................................................passvalid........................................................
  passvalid(event) {
    let str = event.target.value;
    if (str.match(/[a-z]/g) && str.match(
      /[A-Z]/g) && str.match(
        /[0-9]/g) && str.match(
          /[^a-zA-Z\d]/g) && str.length >= 8) {
      this.passerror = false;
    }
    else {
      this.passerror = true;
    }
  }
  //.................................................deletetotalTimesheet........................................................
  deletetotalTimesheet() {
    let obj = { Admin_Password: this.deleteList.admin_Password, SerialNumber: this.editserialnumber, TimesheetIds: this.timesheetsToDelete }
    let url = "api/Timesheet/deletetotalTimesheet"
    this.CommonAPI.DeleteFunctionForPostHttp(obj, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.deleteList = new deletepermission();
      this.editserialnumber = 0;
      this.ApplyFilter();
      this.passerror = false;
      this.resetPass.reset()
      this.toastrService.success(
        'Timesheet deleted successfully!'
      ), 8000;
      document.getElementById("deleteall").click();
      this.ApplyFilter()
      this.passerror = false;
    },
      (err: any) => {
        this.passerror = false;
        this.saveErr = err;
        setTimeout(() => {
          this.saveErr = ""
        }, 8000);
      });
  }
  //.................................................deleteTimesheet........................................................
  deleteTimesheet() {
    let url = "api/Timesheet/DeleteTimesheet";
    this.CommonAPI.DeleteFunctionForPostHttp(this.deleteList, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.deleteList = new deletepermission();
      this.editserialnumber = 0;
      this.ApplyFilter();
      this.passerror = false;
      this.resetPass.reset()
      this.toastrService.success(
        'Timesheet deleted successfully!'
      ), 8000;
      document.getElementById("delete").click();
      this.ApplyFilter()
      this.passerror = false;
    },
      (err: any) => {
        this.passerror = false;
        this.saveErr = err;
        setTimeout(() => {
          this.saveErr = ""
        }, 8000);
      }
    );
  }
  //.................................................CancelDelete........................................................
  CancelDelete() {
    this.deleteList = new deletepermission();
    this.editserialnumber = 0;
    this.passerror = false;
    this.resetPass.reset()
  }
  //.................................................openedit........................................................
  openedit(args: any) {
    var grid = (parentsUntil(args.target, 'e-grid') as any);
    this.result2 = grid.ej2_instances[0]?.getRowInfo(args.target).rowData;
    let id = this.result2.timeSheetId;
    let val1;
    val1 = this.TimesheetLst?.filter(s => s.serialNumber == this.result2.serialNo);
    let val = val1[0]?.timesheet?.filter(t => t.id == id);
    this.editid = id;
    this.editClient = val[0]?.clientName;
    this.editEmployee = val[0]?.employeeName;
    this.editDate = this.datePipe.transform(val[0]?.timesheetDate, 'MM/dd/yyyy');
    this.editNotes = val[0]?.timesheetNotes;
    this.GridType = "child";
    this.clientId = val[0].clientId;
    this.getAuthorizationDetails();
    this.edittime = val[0]?.totalHours;
    this.editservice = val[0]?.masterServiceId;
   
    this.masterServiceId = parseInt(val1[0]?.timesheet[0]?.masterServiceId?.toString());
    this.clientAuthorizationId = val[0]?.authorizationId;
    
    

    document.getElementById("update").click();
  }
  //.................................................UpdateTimesheetView........................................................
  UpdateTimesheetView() {
    let temp: any = [];
    let val1 = this.TimesheetLst?.filter(s => s.serialNumber == this.result2.serialNo);
    let val = val1[0]?.timesheet?.filter(t => t.id == this.result2.timeSheetId);
    temp = {
      Id: this.editid,
      TotalHours: parseFloat(this.edittime),
      EmployeeId: val[0]?.employeeId,
      ClientId: val[0]?.clientId,
      MasterServiceId: parseInt(this.editservice),
      TimesheetDate: (this.editDate != null && this.editDate != undefined && this.editDate != '') ? this.global.getDateTimeString(this.editDate) : null,
      TimesheetNotes: this.editNotes,
      GroupPayorId: val[0]?.groupPayorId,
      authorizationId: parseInt(this.clientAuthorizationId)
    }
    let url = "api/Timesheet/updateTimesheet"
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(temp, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toastrService.success(
        'Timesheets updated successfully!'
      ), 8000;
      document.getElementById("update").click();
      this.clientAuthorizationId = null
      this.ApplyFilter();
    },
      (err: any) => {
        this.toastrService.error(
          err,
          "error",
        );
        setTimeout(() => {
          this.toastrService.clear()
        }, 8000);
      })
  }
  //.................................................getTimesheetUpload........................................................
  getTimesheetUpload(id) {
    let myParams = new URLSearchParams();
    myParams.append("serialnumber", id);
    let url = "api/TimesheetUpload/getTimesheetUpload?"
    this.CommonAPI.GetFunctionwithResponseTypeJson(myParams, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.GridTimesheetUploadList = data;
      this.GridTimesheetUploadList.forEach((element, index) => {
        element.serialnumber = index + 1;
      });
    })
  }
  //.................................................uploadTimesheet........................................................
  uploadTimesheet() {
    let obj = {
      SequenceNumber: this.editserialnumber,
      TimesheetUpload: this.filearray,
    }
    let url = "api/TimesheetUpload/saveTimesheetUpload?"
    let param = new URLSearchParams();
    param.append("serialnumber", this.editserialnumber.toString())
    this.CommonAPI.QueryStringWithResponseTypeJson(obj, param, url).pipe(takeUntil(this.onDestroy$)).subscribe(
      (data: any) => {
        this.filearray = [];
        this.toastrService.success(
          'Timesheet upload successfully!',
          'Timesheet upload'), 8000;
        document.getElementById("uploads").click()
        this.getTimesheetUpload(this.editserialnumber)

      },
      (err: any) => {
        this.toastrService.error(
          err,
          "error",
        );
        setTimeout(() => {
          this.toastrService.clear()
        }, 8000);
      })
  }
  //.................................................DownloadUploadedFile........................................................
  DownloadUploadedFile(data) {
    let val = this.GridTimesheetUploadList?.filter(e => e.sequenceNumber == data.sequenceNumber && e.timesheetUploadName == data.timesheetUploadName);
    if (val.length != 0) {
      window.open(val[0].uploadtimesheet);
    }
  }
  //.................................................FunctionPermission........................................................
  FunctionPermission() {
    let params = new URLSearchParams();
    params.append("pagecode", "Timesheets");
  //  params.append("roleId", this.global.roleId);
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data != null) {
        this.fp = data;
      }
      else {
        this.fp = new functionpermission();
      }
    },
      (err: HttpErrorResponse) => {
        this.fp = new functionpermission();
      })
  }
  //.................................................onResize........................................................
  onResize(args) {
    if (this.ColumnArray != null && this.ColumnArray != undefined) {
      const column = this.gridTimesheet.getColumnByField(args.column.field)
      column.width = args.column.width;
      this.ColumnArray.forEach(element => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });
      // this.SaveColumnwidth();
    }
  }
  //.................................................onResize_timesheetupload........................................................
  onResize_timesheetupload(args) {
    if (this.ColumnArray_timesheetupload != null && this.ColumnArray_timesheetupload != undefined) {
      const column = this.gridTimesheetUpload.getColumnByField(args.column.field)
      column.width = args.column.width;
      this.ColumnArray_timesheetupload.forEach(element => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });
      // this.SaveColumnwidthtiesheetupload();
    }
  }
  //.................................................getColumnwidth........................................................
  getColumnwidth() {
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    this.ColumnArray = this.arraycol[0].Timesheet.Columns;
    this.ColumnArray_timesheetupload = this.arraycol[0].TimesheetViewUpload.Columns;
    let showcol = this.arraycol[0].Timesheet.ShowColumns;
    let hidecol = this.arraycol[0].Timesheet.HideColumns;
    this.gridTimesheet.hideColumns(hidecol);
    if (this.global.globalColumn.userid != null && this.global.globalColumn.agencyId != null) {
      this.id = this.global.globalColumn.id;
    }
    this.gridTimesheet.pageSettings.pageSize = this.arraycol[0].Timesheet.Pagesize;
    this.sorting.itemperpage = this.gridTimesheet.pageSettings.pageSize;
    this.ColumnArray.forEach(element => {
      // Client
      if (element.column == 'Client') {
        const column = this.gridTimesheet.getColumnByField('clientName');
        column.width = element.width;
        this.gridTimesheet.refreshHeader();
      }
      // Employee
      if (element.column == 'Employee') {
        const column1 = this.gridTimesheet.getColumnByField('EmployeeName');
        column1.width = element.width;
        this.gridTimesheet.refreshHeader();
      }
       // Employee
       if (element.column == 'Service Code') {
        const column1 = this.gridTimesheet.getColumnByField('masterCode');
        column1.width = element.width;
        this.gridTimesheet.refreshHeader();
      }
      // From Date
      if (element.column == 'From Date') {
        const column2 = this.gridTimesheet.getColumnByField('fromDate');
        column2.width = element.width;
        this.gridTimesheet.refreshHeader();
      }
      // To Date
      if (element.column == 'To Date') {
        const column3 = this.gridTimesheet.getColumnByField('toDate');
        column3.width = element.width;
        this.gridTimesheet.refreshHeader();
      }
      // Total Hours
      if (element.column == 'Total Hours') {
        const column1 = this.gridTimesheet.getColumnByField('totalhrs');
        column1.headerText = element.column;
        column1.width = element.width;
        this.gridTimesheet.refreshHeader();
      }
      // Timesheet Status
      if (element.column == 'Timesheet Status') {
        const column4 = this.gridTimesheet.getColumnByField('timesheetStatusLid');
        column4.width = element.width;
        this.gridTimesheet.refreshHeader();
      }
      // E-Timesheet
      if (element.column == 'E-Timesheet') {
        const column4 = this.gridTimesheet.getColumnByField('eTimesheet');
        column4.width = element.width;
        this.gridTimesheet.refreshHeader();
      }
      // Employee Signature
      if (element.column == 'Employee Signature') {
        const column4 = this.gridTimesheet.getColumnByField('isEmpSignature');
        column4.width = element.width;
        this.gridTimesheet.refreshHeader();
      }
      // Housing Case Note
      if (element.column == 'Housing Case Note') {
        const column4 = this.gridTimesheet.getColumnByField('housingCaseNote');
        column4.width = element.width;
        this.gridTimesheet.refreshHeader();
      }
      // Employment Service
      if (element.column == 'Employment Service') {
        const column4 = this.gridTimesheet.getColumnByField('employmentService');
        column4.width = element.width;
        this.gridTimesheet.refreshHeader();
      }
      // Client Signature
      if (element.column == 'Client Signature') {
        const column4 = this.gridTimesheet.getColumnByField('isCliSignature');
        column4.width = element.width;
        this.gridTimesheet.refreshHeader();
      }
      // Paid Payroll
      if (element.column == 'Paid Payroll') {
        const column3 = this.gridTimesheet.getColumnByField('paidpayrolls');
        column3.width = element.width;
        this.gridTimesheet.refreshHeader();
      }
      // Actions
      else if (element.column == 'Actions') {
        const column5 = this.gridTimesheet.getColumnByUid('action');
        column5.width = element.width;
        this.gridTimesheet.refreshHeader();
      }
    });
  }
  //.................................................getColumnwidthtimesheetupload........................................................
  getColumnwidthtimesheetupload() {
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    this.ColumnArray_timesheetupload = this.arraycol[0].TimesheetViewUpload.Columns;
    if (this.global.globalColumn.userid != null && this.global.globalColumn.agencyId != null) {
      this.id = this.global.globalColumn.id;
    }
    this.ColumnArray_timesheetupload.forEach(element => {
      // S.NO.
      if (element.column == 'S.NO.') {
        const column = this.gridTimesheetUpload.getColumnByField('serialnumber');
        column.width = element.width;
        this.gridTimesheetUpload.refreshHeader();
      }
      //Sequence Number
      if (element.column == 'Sequence Number') {
        const column1 = this.gridTimesheetUpload.getColumnByField('sequenceNumber');
        column1.width = element.width;
        this.gridTimesheetUpload.refreshHeader();
      }
      // Timesheet Upload
      if (element.column == 'Timesheet Upload') {
        const column2 = this.gridTimesheetUpload.getColumnByField('timesheetUploadName');
        column2.width = element.width;
        this.gridTimesheetUpload.refreshHeader();
      }
      // Actions
      else if (element.column == 'Actions') {
        const column5 = this.gridTimesheetUpload.getColumnByUid('action');
        column5.width = element.width;
        this.gridTimesheetUpload.refreshHeader();
      }
    });
  }
  //.................................................SaveColumnwidth........................................................
  SaveColumnwidth() {
    this.arraycol[0].Timesheet.Columns = this.ColumnArray;
    this.arraycol[0].TimesheetViewUpload.Columns = this.ColumnArray_timesheetupload;
    this.arraycol[0].Timesheet.Pagesize = this.gridTimesheet.pageSettings.pageSize;
    this.columnchange.userid = parseInt(this.global.userID);
    this.columnchange.column = JSON.stringify(this.arraycol);
    this.columnchange.id = this.id;
    this.global.globalColumn = this.columnchange;
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    let url = "api/ColumnChange/Savewidth?";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.columnchange, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.getColumnwidth();
    });
  }
  //.................................................SaveColumnwidthtiesheetupload........................................................
  SaveColumnwidthtiesheetupload() {
    this.arraycol[0].TimesheetViewUpload.Columns = this.ColumnArray_timesheetupload;
    this.columnchange.userid = parseInt(this.global.userID);
    this.columnchange.column = JSON.stringify(this.arraycol);
    this.columnchange.id = this.id;

    this.global.globalColumn = this.columnchange;
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    let url = "api/ColumnChange/Savewidth?";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.columnchange, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.getColumnwidthtimesheetupload();
    });
  }
  //.................................................changeValue........................................................
  changeValue(event: any) {
    if (event.target.name == "totalHours") {
      if (((event.which < 48 && (event.which != 8 && event.which != 46 && event.which != 39 && event.which != 37)) || event.which > 57) && ((event.which < 96 && (event.which != 8 && event.which != 46 && event.which != 39 && event.which != 37)) || event.which > 105)) {
        event.preventDefault();
      }
    }
  }
  //.................................................view271details........................................................
  view271details() {
    let param = new URLSearchParams();
    param.append('id', this.Client.toString())
    let url = "api/ClaimProcess/GetClients271Detail?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(param, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      // this.edi271list = data;

      if (data == null || data.length == 0) {
        this.toastrService.error("Data Note Found");
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      }
      else {
        document.getElementById("openModal34").click();
        this.viewFiles271 = true;
      }
    },
      (err: any) => {
        this.toastrService.error(err);
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      }
    );
  }
  //.................................................selectToDelete........................................................
  selectToDelete(data) {
    let val1 = this.TimesheetLst.filter(s => s.serialNumber == data.serialNo);
    this.timesheetsToDelete = val1[0].timesheet.map(t => t.id);
    this.editserialnumber = data.serialNo;
  }
  //.................................................getClientDropDown........................................................
  getClientDropDown() {
    let params = new URLSearchParams();
    params.append("LocationId", this.locationLid);
    // let url = "api/Client/GetAllClientsDropDownbyAgency?"
    let url = "api/Client/GetAllClientsDropDownbyAgency?"
    this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.AllClientDropDownList = data;
      this.AllClientDropDownList.forEach((clientRecords) => {
        clientRecords.id = clientRecords.id;
        clientRecords.names = clientRecords.names +  " (" + clientRecords.status + ")";
        if(clientRecords.medicaid)
          clientRecords.names+= " (" + clientRecords.medicaid +" ) ";

      });

      this.AllClientDropDownListwithStatus = JSON.parse(JSON.stringify(data));

      this.ViewInputProperty.ClientDropDown = this.AllClientDropDownList?.filter(e => e.status == "ACTIVE");
    });
  }
  //.................................................getAllEmployeeDropDown........................................................
  getEmployeeDropDown() {
    let params = new URLSearchParams();
    params.append("LocationId", this.locationLid);
   // let url = "api/Employee/GetTimesheetEmployeesDropDownbyAgency?"
    let url = "api/Employee/GetTimesheetEmployeesDropDownbyAgency?"
    this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.AllEmployeeDropDownList = data;
      this.AllEmployeeDropDownListwithStatus = JSON.parse(JSON.stringify(data));
      this.AllEmployeeDropDownListwithStatus.forEach((employeeRecords) => {
        employeeRecords.id = employeeRecords.id;
        employeeRecords.names =
          employeeRecords.names +
          " (" +
          employeeRecords.status + ")"
      });
      this.ViewInputProperty.EmployeeDropDown = this.AllEmployeeDropDownList?.filter(e => e.status == "ACTIVE");
    });
  }
  //.................................................closetimesheetUpload........................................................
  closetimesheetUpload() {
    document.getElementById('uploads').click();
  }
  //.................................................showColumn........................................................
  showColumn() {
    this.gridTimesheet.columnChooserModule.openColumnChooser(500, -250);
  }
  //.................................................printtimesheet........................................................
  printtimesheet() {
    if ((this.filters.filterStartDate == undefined || this.filters.filterStartDate == "") &&
      (this.filters.filterEndDate != undefined && this.filters.filterEndDate != "") ||
      ((this.filters.filterEndDate == undefined || this.filters.filterEndDate == "") && (this.filters.filterStartDate != undefined && this.filters.filterStartDate != ""))) {


      this.toastrService.error('select start and end date', 'Warning');
      setTimeout(() => {
        this.toastrService.clear();
      }, 8000);
      return;
    }
    if (new Date(this.filters.filterStartDate).getTime() > new Date(this.filters.filterEndDate).getTime()) {
      this.toastrService.error('End date should be greater than Start date', 'Warning');
      setTimeout(() => {
        this.toastrService.clear();
      }, 8000);
      return;
    }
    if (this.filters.filterEmployee == null || this.filters.filterEmployee == undefined) {
      this.filters.filterEmployee =  "00000000-0000-0000-0000-000000000000"
    }
    if (this.filters.filterClient == null || this.filters.filterClient == undefined) {
      this.filters.filterClient =  "00000000-0000-0000-0000-000000000000"
    }
    if (this.filters.filterPayor == null || this.filters.filterPayor == undefined) {
      this.filters.filterPayor =  "00000000-0000-0000-0000-000000000000"
    }
    if (this.printserviceFilter == null || this.printserviceFilter == undefined || this.printserviceFilter == '') {
      this.printserviceFilter = 0;
    }
    this.gettimesheet.client = this.timesheetreportClient.toString();
    this.gettimesheet.payor = (this.filters.filterPayor.toString());
    this.gettimesheet.pageitem = parseInt(this.sorting.itemperpage.toString());
    this.gettimesheet.employee = (this.timesheetreportEmployee.toString());
    this.gettimesheet.service = (this.printserviceFilter.toString());
    this.gettimesheet.start = (new Date(new Date(this.filterStartDateTimesheet).toDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "");
    this.gettimesheet.end = (new Date(new Date(this.filterEndDateTimesheet).toDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "");
    this.gettimesheet.currentpageno = this.sorting.currentPgNo;
    this.gettimesheet.orderColumn = this.sorting.shortcolumn;
    this.gettimesheet.orderType = this.sorting.shortType;
    this.gettimesheet.locationLid = this.locationLid;
    let url = "api/Timesheet/printtimesheet";
    this.CommonAPI.GetFunctionwithResponseTypeJson(this.gettimesheet, url).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {

      if (data.timesheets != null && data.timesheets.length > 0) {
        document.getElementById("printtimesheet").click();
        var a = window.open('', '', 'height=700, width=700');
        a.document.write('<html>');
        a.document.write('<body ><table class="table table-hover table-bordered table-responsive" style="margin-top: 5px;margin-left: 10px;border:solid #000 !important; border-width:1px 0 0 1px !important;">');
        a.document.write('<thead>');
        a.document.write('<th style="border:solid #000 !important;border-width:0 1px 1px 0 !important;border-top:1px">Employee Name</th>');
        a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Client Name</th>');
        a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Payer Name</th>');
        a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Service</th>');
        a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Date</th>');
        a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Hours</th>');
        a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Notes</th>');


        a.document.write('</thead>');
        a.document.write('<tbody>');
        data.timesheets.forEach(element => {
          a.document.write('<tr style="border:solid #000 !important; border-width:1px 0 0 1px !important;">');

          a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + element.employeeName + '</td>');
          a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + element.clientName + '</td>');
          a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + ((element.payerName == null || element.payerName == 'null') ? "" : element.payerName) + '</td>');
          a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + element.masterCode + '</td>');
          a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.timesheetDate != null ? this.datePipe.transform(element.timesheetDate, "MM/dd/yyyy") : "") + '</td>');
          a.document.write(' <td style="text-align: right;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + element.totalHours + '</td>');
          a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + ((element.timesheetNotes == null || element.timesheetNotes == 'null') ? "" : element.timesheetNotes) + '</td>');
          a.document.write('</tr>');
        });
        a.document.write('<tr style="border:solid #000 !important; border-width:1px 0 0 1px !important;">');

        a.document.write('<td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;" colspan="5"> Total Hours </td>');
        a.document.write('<td style="text-align: right;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + data.grandTotal + '</td>');
        a.document.write('<td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;"></td>');
        a.document.write('</tr>');
        a.document.write(' </tbody>  </table>');

        //  a.document.write(printContents); 
        a.document.write('</body></html>');
        a.document.close();

        a.print();
      }
      else {
        this.toastrService.error('No Data Available', 'Warning');
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      }
    })
  }
  //.................................................numberonly........................................................
  numberonly(event: any, type) {
    this.ref.detach();
    setInterval(() => {
      this.ref.detectChanges();
    }, 10);
    if (((event.which < 48 && (event.which != 8 && event.which != 46 && event.which != 39 && event.which != 37)) || event.which > 57) && ((event.which < 96 && (event.which != 8 && event.which != 46 && event.which != 39 && event.which != 37)) || event.which > 105)) {
      event.preventDefault();
    }
    let txt = "";
    if (type == "update") {
      txt = this.edittime;
    }
    txt = (txt.trim) ? txt.trim() : txt.replace(/^\s+/, '');
    if (txt.length == 1) {
      if (txt == "2") {
        if (event.key > 4) {
          event.preventDefault();
        }
      }
      if (parseInt(txt) > 2) {
        if (event.which != 46) {
          event.preventDefault();
        }
      }
      if (txt == '.') {
        if (!(event.which == 50 || event.which == 53 || event.which == 55 || event.which == 48)) {
          event.preventDefault();
        }
      }
    }
    if (txt.length == 2) {
      if (txt == '24') {
        event.preventDefault();
      }
      else {
        let tempdata = txt.split("");
        if (!(tempdata[1] == ".")) {
          if (tempdata[0] == ".") {
            if (tempdata[1] == "5" || tempdata[1] == "0") {
              if (!(event.which == 48)) {
                event.preventDefault();
              }
            }
            if (tempdata[1] == "2" || tempdata[1] == "7") {
              if (!(event.which == 53)) {
                event.preventDefault();
              }
            }
          }
          else if (event.which != 46) {
            event.preventDefault();
          }
        }
        else {
          if (!(event.which == 50 || event.which == 53 || event.which == 55 || event.which == 48)) {
            event.preventDefault();
          }
        }
      }
    }
    if (txt.length == 3) {
      let tempdata = txt.split("");
      if (tempdata[0] == ".") {
        event.preventDefault();
      }
      if (tempdata[2] == ".") {
        if (!(event.which == 50 || event.which == 53 || event.which == 55 || event.which == 48)) {
          event.preventDefault();
        }
      }
      if (tempdata[1] == ".") {
        let tempdata1 = txt.split(".");
        if (tempdata1[1] == "5" || tempdata1[1] == "0") {
          if (!(event.which == 48)) {
            event.preventDefault();
          }
        }
        if (tempdata1[1] == "2" || tempdata1[1] == "7") {
          if (!(event.which == 53)) {
            event.preventDefault();
          }
        }
      }
    }
    if (txt.length == 4) {
      let tempdata = txt.split(".");
      if (tempdata[1].length == 2) {
        event.preventDefault();
      }
      if (tempdata[1] == "5" || tempdata[1] == "0") {
        if (!(event.which == 48)) {
          event.preventDefault();
        }
      }
      if (tempdata[1] == "2" || tempdata[1] == "7") {
        if (!(event.which == 53)) {
          event.preventDefault();
        }
      }
    }
    if (txt.length > 4) {
      event.preventDefault();
    }
  }
  //.................................................newTimeSheetdate........................................................
  newTimeSheetdate(event, type, name) {
    if (type == "inputchanged") {
      if (name == 'filtertimesheetstart') {
        let value = this.dateservice.inputFeildchangeReturnall(event);
        if (value != undefined) {
          let value1 = this.dateservice.inputFeildchangeReturnall(event);
          let enddate = new Date(event.value);
          enddate.setDate(enddate.getDate() + 6);
          this.filterEndDateTimesheet = (enddate.getMonth() + 1) + '/' + enddate.getDate() + '/' + enddate.getFullYear();
          this.filterStartDateTimesheet = value1;

        }
      }
      if (name == 'filtertimesheetend') {
        let value = this.dateservice.inputFeildchangeReturnall(event);
        if (value != undefined) {
          let value1 = this.dateservice.inputFeildchangeReturnall(event);
          let enddate = new Date(event.value);
          enddate.setDate(enddate.getDate() + 6);
          this.filterEndDateTimesheet = (enddate.getMonth() + 1) + '/' + enddate.getDate() + '/' + enddate.getFullYear();
          this.filterEndDateTimesheet = value1;

        }
      }

    }
    if (type == "datachanged") {
      if (name == 'filtertimesheetstart') {
        let value = this.dateservice.Datechange(event);
        if (value != undefined) {
          let value1 = this.dateservice.Datechange(event);
          let enddate = new Date(event.value);
          enddate.setDate(enddate.getDate() + 6);
          this.filterEndDateTimesheet = (enddate.getMonth() + 1) + '/' + enddate.getDate() + '/' + enddate.getFullYear();

          this.filterStartDateTimesheet = value1;


        }
      }
      if (name == 'filtertimesheetend') {
        let value = this.dateservice.Datechange(event);
        if (value != undefined) {
          let value1 = this.dateservice.Datechange(event);
          let enddate = new Date(event.value);
          enddate.setDate(enddate.getDate() + 6);
          this.filterEndDateTimesheet = (enddate.getMonth() + 1) + '/' + enddate.getDate() + '/' + enddate.getFullYear();
          this.filterEndDateTimesheet = value1;

        }
      }
    }
  }
  //.................................................clearPrintTImeSheetValues........................................................
  clearPrintTImeSheetValues() {
    document.getElementById("printtimesheet").click();
    this.timesheetreportClient = "";
    this.timesheetreportEmployee = "";
    this.printserviceFilter = "";
  }

  //.................................................generateTimesheetReport........................................................
  generateTimesheetReport() {
    if (this.printserviceFilter == null || this.printserviceFilter == undefined || this.printserviceFilter == '') {
      this.printserviceFilter = null;
    }
    let currentTime = this.datePipe.transform(new Date(), "MM/dd/yyyy hh:mm a");
    this.checkReport = true;
    this.reportHeader = "Timesheet Report";

    this.CommonAPI.CommonFunctionforPowerBiToken().then((token) => {
      document.getElementById("OpenReportModal").click();
      let embedUrl =
        "https://app.powerbi.com/rdlEmbed?reportId=" +
       this.configuration.TimesheetReportId +
        "&rp:ExecutionTime=" +
        currentTime +
        "&rp:agencyid=" +
        this.global.globalAgencyId +
        "&rp:clientid=" +
        this.timesheetreportClient +
        "&rp:employeeid=" +
        this.timesheetreportEmployee
        +
        "&rp:startdate=" +
        this.global.getDateTimeString(this.filterStartDateTimesheet) +
        "&rp:enddate=" +
        this.global.getDateTimeString(this.filterEndDateTimesheet)
        +
        "&filterPaneEnabled=False&rdl:parameterPanel=hidden";

       let embedReportId = this.configuration.TimesheetReportId;
      let config = {
        type: "report",
        tokenType: pbi.models.TokenType.Aad,
        accessToken: token[0],
        embedUrl: embedUrl,
        id: embedReportId,
        settings: {},
        viewmode: pbi.models.ViewMode.View,
      };
      let reportContainer = this.reportContainer.nativeElement;
      let powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      );
      let report = powerbi.embed(reportContainer, config);
      report.off("loaded");
      report.on("loaded", () => { });
    });
  }
  //.................................................setDocumentId........................................................
  setDocumentId(data) {
    this.deleteId = data.id
    this.serialNo = data.sequenceNumber
  }
  //.....................................................DeleteDocumentfile..............................................
  DeleteDocumentfile() {
    let params = new URLSearchParams();
    params.append("Id", this.deleteId);
    let url = "api/TimesheetUpload/deleteTimesheetUpload?";
    this.CommonAPI.DeleteFunctionForDeleteHttp(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      this.toastrService.success('Deleted successfully!')
      document.getElementById('openDelete').click()
      this.getTimesheetUpload(this.serialNo);
      setTimeout(() => {
        this.toastrService.clear();
      }, 8000);
    },
      (err: any) => {
        this.toastrService.error(err);
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      })
  }
  //.................................................closeDeleteModal........................................................
  closeDeleteModal() {
    document.getElementById('openDelete').click();
  }
  //.................................................showPayrollNotification........................................................
  showPayrollNotification(paidpayrolls) {
    if (paidpayrolls == true || paidpayrolls == 'YES') {
      document.getElementById('showPaidpayroll').click()
    }
    else {
      document.getElementById('deleteall').click()
    }
  }
  //.................................................closePayrollNotification........................................................
  closePayrollNotification() {
    document.getElementById('showPaidpayroll').click()
  }
  //.................................................showPayrollNotificationinchild........................................................
  showPayrollNotificationinchild(paidpayroll) {
    if (paidpayroll == true || paidpayroll == 'YES') {
      document.getElementById('showPaidpayrollchild').click()
    }
    else {
      document.getElementById("delete").click()
    }
  }
  //.................................................closePayrollNotificationinchild........................................................
  closePayrollNotificationinchild() {
    document.getElementById('showPaidpayrollchild').click()
  }
  //.................................................getserviceCode........................................................
  getServiceCode() {
    let param = new URLSearchParams();
    this.ViewInputProperty.ServiceCode = [];
    // if (this.serviceGroupFilter != 0 && this.serviceGroupFilter != null
    //   && this.serviceGroupFilter != undefined) {
      // param.append("GroupId", this.serviceGroupFilter.toString())
      let url = "api/Service/GetServiceDropdown?";
      this.CommonAPI.GetFunctionwithResponseTypeJson(param, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any[]) => {
        this.ViewInputProperty.ServiceCode = JSON.parse(JSON.stringify(data))
        this.ServiceCodeFilter = null;
        this.ViewInputProperty.ServiceCode.forEach(element => {
          element.Value = element.Value;
          element.Key = element.Key?.toString();
        });
      })
    // }
    // else {
    //   this.serviceGroupFilter = 0;
    //   this.ServiceCodeFilter = 0;
    //   param.append("GroupId", this.serviceGroupFilter?.toString())
    //   let url = "api/MasterService/GetServiceDrop?";
    //   this.CommonAPI.GetFunctionwithResponseTypeJson(param, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any[]) => {
    //     this.ViewInputProperty.ServiceCode = JSON.parse(JSON.stringify(data))
    //     this.ViewInputProperty.ServiceCode.forEach(element => {
    //       element.Value = element.masterServiceName;
    //       element.Key = element.id?.toString();

    //     });
    //   })
    // }
  }
  //.................................................getCommonClientListByAgency........................................................
  getCommonClientListByAgency() {
    let param = new URLSearchParams();
    let locId;
    if (this.global.globalLocationId != null && this.global.globalLocationId != ''
      && this.global.globalLocationId != undefined) {
      locId = parseInt(this.global.globalLocationId);
    }
    else {
      locId = 0;
    }
    param.append("LocationId", locId);
    let url = "api/Client/GetCommonClientListByAgency?"
    this.CommonAPI.GetFunctionwithResponseTypeJson(param, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any[]) => {
      this.ViewInputProperty.ActiveInactiveClient = data;
    })
  }

  selectSpecifyService(specifyAuthorizationdetails) {
  
    this.clientAuthorizationId = specifyAuthorizationdetails.id;
    this.editservice = specifyAuthorizationdetails.masterserviceId.toString();
    this.AuthorizationDetails?.forEach(element => {
      if (element.id == this.clientAuthorizationId) {
        element.isAuthBoolean = true;
      }
      else {
        element.isAuthBoolean = false;
      }
    });

  }

  getAuthorizationDetails() {
    let startDate = "";
    let endDate = "";
    if (this.GridType == "child") {
      startDate = this.editDate;
      endDate = this.editDate;
    }
    else {
      startDate = this.StartDate;
      endDate = this.EndDate;
      this.clientId = (this.editcli == null || this.editcli == undefined || this.editcli == '') ? 0 : this.editcli;
    }
    this.editservice=null;
    this.clientAuthorizationId=null;
    let parameter = new URLSearchParams();
    parameter.append("startdate", this.global.getDateTimeString(startDate))
    parameter.append("enddate", this.global.getDateTimeString(endDate))
    parameter.append("clientid", parseInt(this.clientId).toString())
    let url = "api/Timesheet/FilteracctoStartdate?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(parameter, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      let i;
      this.serviceName = "";
      let service = [];
      data?.forEach(element => {
        if (element.remaingHours <= 100) {
          element.isColorEditValue = true;
        }
        else {
          element.isColorEditValue = false;
        }
      });
      if (data.length != 0) {
        for (i = 0; i < data.length; i++) {
          data[i].Value = data[i].masterServiceCode + "," + data[i].serviceDesc;
          data[i].Key = data[i].masterserviceId.toString();
          service[i] = { value: data[i].masterServiceCode, label: data[i].masterServiceCode, key: data[i].masterServiceId };
          let hrMinStr = data[i].hoursPerDay.toString().split('.');
          if (hrMinStr.length == 1) {
            data[i].hoursPerDay = hrMinStr[0] + " hr " + "0 Min";
          }
          else {
            let minStr = 0 + "." + hrMinStr[hrMinStr.length - 1];
            data[i].hoursPerDay = hrMinStr[0] + " hr " + (parseFloat(minStr) * 60).toString().split('.')[0] + "Min";
          }
          let hoursPerDayBasedOnLastVisitDateString = data[i].hoursPerDayBasedOnLastVisitDate?.toString().split('.');
          if (hoursPerDayBasedOnLastVisitDateString.length == 1) {
            data[i].hoursPerDayBasedOnLastVisitDate = hoursPerDayBasedOnLastVisitDateString[0] + " hr " + "0 Min";
          }
          else {
            let minStr = 0 + "." + hoursPerDayBasedOnLastVisitDateString[hoursPerDayBasedOnLastVisitDateString.length - 1];
            data[i].hoursPerDayBasedOnLastVisitDate = hoursPerDayBasedOnLastVisitDateString[0] + " hr " + (parseFloat(minStr) * 60).toString().split('.')[0] + "Min";
          }
          if (data[i].remaingHours <= 100) {
            this.isColorEditValue[i] = true;
          }
          else {
            this.isColorEditValue[i] = false;
          }
          let hrMinStr1 = data[i].remaingHours.toString().split('.');
          if (hrMinStr1.length == 1) {
            data[i].remaingHours = hrMinStr1[0] + " hr " + "0 Min";
          }
          else {
            let minStr1 = 0 + "." + hrMinStr1[hrMinStr1.length - 1];
            data[i].remaingHours = hrMinStr1[0] + " hr " + (parseFloat(minStr1) * 60).toString().split('.')[0] + "Min";
          }
          let hrperWeekMinStr = data[i].hoursPerWeek.toString().split('.');
          if (hrperWeekMinStr.length == 1) {
            data[i].hoursPerWeek = hrperWeekMinStr[0] + " hr " + "0 Min";
          }
          else {
            let minStr = 0 + "." + hrperWeekMinStr[hrperWeekMinStr.length - 1];
            data[i].hoursPerWeek = hrperWeekMinStr[0] + " hr " + (parseFloat(minStr) * 60).toString().split('.')[0] + "Min";
          }
        }
      }
      this.AuthorizationDetails = data;
      this.AuthorizationDetails?.forEach(element => {
        if (element.id == this.clientAuthorizationId) {
          element.isAuthBoolean = true;
        }
        else {
          element.isAuthBoolean = false;
        }
      });
      let servicetype: any = this.editservice;
      if (servicetype != null) {
        this.editservice = parseInt(servicetype).toString();
      }
    })
  }
  getClientAuth() {
    if (this.editservice != null && this.editservice != undefined && this.editservice != 0) {
      let clientAuthDetails = this.AuthorizationDetails?.filter(a => a.masterserviceId == this.editservice)[0]
      this.clientAuthorizationId = clientAuthDetails.id;
      
    }
    else 
    {
      this.clientAuthorizationId=null;
    }
    this.AuthorizationDetails?.forEach(element => {
      if (element.id == this.clientAuthorizationId) {
        element.isAuthBoolean = true;
      }
      else {
        element.isAuthBoolean = false;
      }
    });

  
  }
   //.................................................AddClientAuthorization........................................................
   AddClientAuthorization() {
    this.authinput.ClientId = this.clientId.toString();
    this.authinput.isEdit = true;
    this.authinput.type = "new";
    this.authinput.isEditAuthorization = true;
    this.authinput.isView = false;
    this.EditAuthorization = true;
  }
   //.................................................dataEmitfromChild........................................................
   dataEmitfromChild(event: EditDetailsAuthorization) {
    this.EditAuthorization = false;
    this.authinput.isEdit = false;
    this.authinput.isView = true;
    this.authinput = event;
    this.getAuthorizationDetails()
  }

    //......................................exportCareWithPaginationCsv.....................................................
    exportTimesheetWithPaginationCsv() {
      this.gettimesheet.pageitem = this.gridTimesheet.pageSettings.pageSize;
      this.gettimesheet.currentpageno = this.gridTimesheet.pageSettings.currentPage;
      let url = "api/CFSSTimesheet/ExportTimeSheet";
      this.CommonAPI.saveorUpdateFunctionFileSaver(this.gettimesheet, url, "TimesheetReport.csv");
  }
  count:number=0
//...........................................exportCareCsv................................................................
  exportAllTimesheetCsv() {
    this.gettimesheet.pageitem = this.count;
    this.gettimesheet.currentpageno = 1;
      let url = "api/CFSSTimesheet/ExportTimeSheet";
      this.CommonAPI.saveorUpdateFunctionFileSaver(this.gettimesheet, url, "TimesheetReport.csv")
  }
     clearGridLocalStorage(): void {
    // Define grid configurations for visits
    const gridConfigs = [
      { localStorageKey: 'gridTimesheetGrid', expectedColumns: this.timesheetTotalColumns },
    ];
    
    // Use global method for localStorage clearing
    this.global.clearGridIdLocalStorage(gridConfigs);
  }
  //.................................................ngOnDestroy........................................................
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
